// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__dVU1-","label":"styles_label__svSlG","textInput":"styles_textInput__3ho38"};